import { Component, OnInit, OnDestroy, Input } from '@angular/core'
import { IToast, ToastType } from '../../content/interfaces/itoast'
import { ToastService } from './toast.service'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    standalone: false
})
export class ToastComponent implements OnInit, OnDestroy {
  @Input() hidden: boolean

  private unsubscribe = new Subject()
  alert: IToast

  constructor(private alertService: ToastService) {
    this.alertService
      .getAlert()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((alert: IToast) => {
        this.alert = alert
      })
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    this.unsubscribe.next(1)
    this.unsubscribe.complete()
  }

  cssClass() {
    if (!this.alert) {
      return
    }

    if (!this.hidden) {
      // return css class based on alert type
      switch (this.alert.type) {
        case ToastType.Success:
          return 'toastt alert-success'
        case ToastType.Error:
          return 'toastt alert-danger'
        case ToastType.Info:
          return 'toastt alert-info'
        case ToastType.Warning:
          return 'toastt alert-warning'
      }
    } else {
      switch (this.alert.type) {
        case ToastType.Success:
          return 'toastt-hidden alert-success'
        case ToastType.Error:
          return 'toastt-hidden alert-danger'
        case ToastType.Info:
          return 'toastt-hidden alert-info'
        case ToastType.Warning:
          return 'toastt-hidden alert-warning'
      }
    }
  }

  clearToast() {
    this.alertService.clear()
  }
}
